define.alias("shared/components/shared/expandable-radio-card-group", "calendar/components/shared/expandable-radio-card-group");